import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { getFaqsRequest } from '../../api/community';
import { IMAGE_CONSTANT, LOCAL_STORAGE_CONSTANT } from '../../constants/app';
import { extractJSON } from '../../services/jsonUtil';
import { useWebsiteSettings } from '../../contexts/WebsiteSettingsContext';

const bootIntercom = () => {
  if (!window.Intercom) {
    return;
  }

  const user = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
  const properties = {
    app_id: process.env.REACT_APP_INTERCOM_APP_ID,
  };

  if (user?.id) {
    properties.name = user.attributes.name;
    properties.email = user.attributes.email;
    properties.user_id = user.id;
    properties.country_code = user.attributes.country_code;
    properties.phone = user.attributes.mobile;
  }

  window.Intercom('boot', properties);
};

const TechnicalSupportIcon = () => (
  <svg
    aria-hidden="true"
    className="help-support-technical-btn-icon"
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 4.5C4 3.67157 4.67157 3 5.5 3H14.5C15.3284 3 16 3.67157 16 4.5V11.5C16 12.3284 15.3284 13 14.5 13H9.41421L6.70711 15.7071C6.31658 16.0976 5.68342 16.0976 5.29289 15.7071C5.10536 15.5196 5 15.2652 5 15V13H4.5C3.67157 13 3 12.3284 3 11.5V4.5C3 3.67157 3.67157 3 4.5 3Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <circle cx="7" cy="8" fill="currentColor" r="1" />
    <circle cx="10" cy="8" fill="currentColor" r="1" />
    <circle cx="13" cy="8" fill="currentColor" r="1" />
  </svg>
);

const HelpAndSupport = () => {
  const [faqs, setFaqs] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const { websiteSettings } = useWebsiteSettings();

  const supportEmail = websiteSettings?.support_email;

  useEffect(() => {
    bootIntercom();

    getFaqsRequest()
      .then(response => {
        const items = response.data?.data || [];
        setFaqs(items);
        setActiveIndex(items.length ? 0 : null);
      })
      .catch(() => {
        setFaqs([]);
        setActiveIndex(null);
      })
      .finally(() => {
        setIsLoading(false);
      });

    return () => {
      if (window.Intercom) {
        window.Intercom('shutdown');
      }
    };
  }, []);

  const handleToggle = index => {
    setActiveIndex(current => (current === index ? null : index));
  };

  const handleTechnicalSupport = () => {
    if (supportEmail) {
      window.location.href = `mailto:${supportEmail}`;
    } else if (window.Intercom) {
      window.Intercom('show');
    }
  };

  return (
    <div className="profile-form-div-outer">
      <div className="profile-form-div account-settings help-support-page">
        <h2 className="account-settings-title">Support</h2>

        {isLoading ? (
          <div className="help-support-loading">
            <Spinner animation="border" />
          </div>
        ) : (
          <>
            <div className="help-support-faq-list">
              {faqs.map((faq, index) => {
                const isExpanded = activeIndex === index;

                return (
                  <div
                    className={`help-support-faq-item${
                      isExpanded ? ' is-expanded' : ''
                    }`}
                    key={`${faq.question}-${index}`}
                  >
                    <button
                      aria-expanded={isExpanded}
                      className="help-support-faq-question"
                      type="button"
                      onClick={() => handleToggle(index)}
                    >
                      <span>{faq.question}</span>
                      <img
                        alt=""
                        className="help-support-faq-chevron"
                        src={
                          isExpanded
                            ? IMAGE_CONSTANT.chevronUp
                            : IMAGE_CONSTANT.chevronDown
                        }
                      />
                    </button>
                    {isExpanded && (
                      <p className="help-support-faq-answer">{faq.answer}</p>
                    )}
                  </div>
                );
              })}
            </div>

            <button
              className="help-support-technical-btn"
              type="button"
              onClick={handleTechnicalSupport}
            >
              <TechnicalSupportIcon />
              Technical Support
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default HelpAndSupport;
